
<div class="admin-tabs">
  <ul class="admin-tabs__menu">
    <ng-container *ngFor="let tab of tabsArray">
      <li class="admin-tabs__item" *ngIf="tab.visible"><a class="admin-tabs__link" [routerLink]="[tab.url]" routerLinkActive="admin-tabs__link--active">
          <div class="admin-tabs__link-content">{{ tab.title }}</div></a></li>
    </ng-container>
  </ul>
</div>